import { useEffect } from "react";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { MenuUsuario } from "../components/MenuUsuario";
import { Footer } from "../../../components/Landing/Footer";
import { Mispostulaciones } from "./Mispostulaciones";
import { useMisPostulaciones } from "../../../hooks/useMisPostulaciones";
import ModalWarning from "../../../utils/Alerts/ModalWarning";

export const PostulacionesUsuario = () => {
  const {
    cargarPostulaciones,
    setOpenModalWarning,
    openModalWarning,
    onAceptar
  } = useMisPostulaciones();

  useEffect(() => {
    cargarPostulaciones();
  }, []);

  return (
    <>
      <Header />
      <div className="container-fluid2" style={{ paddingTop: "1.5%", paddingBottom: "5%" }}>
        <div className="row">
          <MenuUsuario activeItem={0} />
          <div className="col-12 col-md-12 col-lg-10">
            <Mispostulaciones />
          </div>
        </div>
      </div>
      <Footer />
      <ModalWarning
        visualizar={openModalWarning}
        setVisualizar={setOpenModalWarning}
        titlle="Advertencia"
        onAceptar={onAceptar}
        description={"Tienes documentos pendientes por subsanar"}
        subdescription="Haz clic en el botón 'Subsanar' de tu postulación para cargar los documentos requeridos."
      />
    </>
  );
};
